"use client";

import { c as _c } from "react/compiler-runtime";
import { LandvestHandoffLink } from "@/components/layout/LandvestHandoffLink";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { MegaMenuItem } from "@/components/layout/navigation/MegaMenuItem";
import { MegaMenuChips } from "@/components/layout/navigation/MegaMenuChips";
import type { MegaMenuSection as SectionType } from "@/lib/navigation";
interface MegaMenuSectionProps {
  section: SectionType;
  onItemClick: () => void;
  compact?: boolean;
}
export function MegaMenuSection(t0) {
  const $ = _c(22);
  const {
    section,
    onItemClick,
    compact: t1
  } = t0;
  const compact = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== section.items) {
    t2 = !!section.items?.length && section.items.every(_temp);
    $[0] = section.items;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const plainLinks = t2;
  let t3;
  if ($[2] !== onItemClick || $[3] !== section.href || $[4] !== section.title || $[5] !== section.titleIcon) {
    t3 = section.title && <h4 className="text-xs uppercase tracking-[0.12em] text-secondary font-bold flex items-center gap-2">{section.titleIcon && <section.titleIcon className="w-4 h-4" />}{section.href ? <LandvestHandoffLink href={section.href} onClick={onItemClick} role="menuitem" className="group/heading inline-flex items-center gap-2 hover:text-primary transition-colors">{section.title}<ArrowRight className="w-3.5 h-3.5 group-hover/heading:translate-x-0.5 transition-transform" /></LandvestHandoffLink> : section.title}</h4>;
    $[2] = onItemClick;
    $[3] = section.href;
    $[4] = section.title;
    $[5] = section.titleIcon;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== section.description) {
    t4 = section.description && <p className="-mt-2 text-sm leading-normal text-on-surface-variant">{section.description}</p>;
    $[7] = section.description;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== compact || $[10] !== onItemClick || $[11] !== plainLinks || $[12] !== section.items) {
    t5 = !!section.items?.length && <ul className={cn("flex flex-col", compact ? "gap-0.5" : plainLinks ? "gap-3" : "gap-[18px]")}>{section.items.map(item_0 => <MegaMenuItem key={item_0.id} label={item_0.label} description={item_0.description} href={item_0.href} onClick={onItemClick} compact={compact} plain={plainLinks} />)}</ul>;
    $[9] = compact;
    $[10] = onItemClick;
    $[11] = plainLinks;
    $[12] = section.items;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== onItemClick || $[15] !== section.chips) {
    t6 = section.chips && <MegaMenuChips chips={section.chips} onItemClick={onItemClick} />;
    $[14] = onItemClick;
    $[15] = section.chips;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t7 = <div className="flex flex-col gap-4">{t3}{t4}{t5}{t6}</div>;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}
function _temp(item) {
  return !item.description;
}